import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Importance from './components/Importance';
import MentorsCatalog from './components/MentorsCatalog';
import Registration from './components/Registration';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <HowItWorks />
      <Importance />
      <MentorsCatalog />
      <Registration />
      <Footer />
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSfIbs5Pd7eOgmOLfATe-M_ojlLTBa9bGCFcALdfSPtvqnGDgA/viewform?usp=send_form"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full bg-teal-600 px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-teal-900/30 transition hover:scale-[1.02] hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-400"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          className="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 5v14m-7-7h14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Regístrate
      </a>
    </div>
  );
}